import * as React from "react";
import PortalPanel from "../../shared/PortalPanel";
import history from "utils/history";
import { timeoutSvg } from "utils/StaticPaths";
const SessionTimeout: React.FC<{}> = () => {
  return (
    <div className="h-100 portal-login-backdrop">
      <PortalPanel
        image={timeoutSvg}
        title="Your session has timed out!"
        subtitle="You have been signed out due to inactivity. Please sign in again to the Marble Portal."
        primaryButton={{
          text: "Sign in again",
          action: () => history.push("/"),
        }}
      ></PortalPanel>
    </div>
  );
};

export default SessionTimeout;
